import React, { useState } from 'react'
import constants, { getInitials } from '../constants'
import { useThemeColor } from '../../hooks/useThemeColor'
import { useOrganizationLogo } from '../../hooks/useOrganizationLogo'
import Button from '../atomic/Button'
import {ReactComponent as History} from '../../assets/history.svg'
import {ReactComponent as Stars} from '../../assets/stars.svg'
import {ReactComponent as Settings} from '../../assets/settings.svg'
import {ReactComponent as ChatNavbarIcon} from '../../assets/chat_navbar.svg'
import {ReactComponent as HilfeIcon} from '../../assets/hilfe_center.svg'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ChatSelected from '../../assets/chat_selected.png';
import ChatUnselected from '../../assets/chat_unselected.png';

const Nav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = useSelector((state) => state.admin);
  const { aispaceColor } = useThemeColor();
  const { logoUrl, loading } = useOrganizationLogo();
  const isSuperAdmin = data?.user_role === "SUPER_ADMIN";

  const [showLogout, setShowLogout] = useState(false);
  const [hideTimeout, setHideTimeout] = useState(null);
  
  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      const profileElement = document.getElementById('profile-dropdown');
      if (profileElement && !profileElement.contains(event.target) && showLogout) {
        setShowLogout(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showLogout]);

  const handleMouseEnter = () => {
    if (hideTimeout) clearTimeout(hideTimeout);
    setShowLogout(true);
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      setShowLogout(false);
    }, 200);
    setHideTimeout(timeout);
  };

  const name = localStorage.getItem("name");
  const initials = getInitials(name);

  const logout = () => {
    localStorage.clear();
    const logoutUrl = "https://login.microsoftonline.com/common/oauth2/v2.0/logout";
    const postLogoutRedirectUri = encodeURIComponent("http://localhost:3000");
    window.location.href = `${logoutUrl}?post_logout_redirect_uri=${postLogoutRedirectUri}`;
  };

  const routes = [
    ...(data?.user_role !== 'No License' ? [{
      path: "/", 
      text: "Analyse", 
      icon: (isActive) => (
        <div style={{ color: isActive ? aispaceColor : "#5F6368" }}>
          <Stars  height={20} width={20}/>
        </div>
      )
    }] : []),
    // ...(data?.user_role !== 'No License' ? [{

    // Chat functionality is temporarily disabled
    // {
    //   path: "/chat",
    //   text: "Chat",
    //   disabled: true, // Add disabled property
    //   icon: (isActive) => (
    //     <ChatNavbarIcon 
    //       height={20} 
    //       width={20} 
    //       fill={isActive ? aispaceColor : "#5F6368"} 
    //     />
    //   )
    // },
    ...(data?.user_role !== 'No License' ? [{ 
      path: "/history", 
      text: "Verlauf", 
      icon: (isActive) => (
        <div style={{ color: isActive ? aispaceColor : "#5F6368" }}>
          <History height={20} width={20}/>
        </div>
      )
    }] : []),
    { 
      path: "/hilfe", 
      text: "Hilfe Center", 
      icon: (isActive) => (
        <div style={{ color: isActive ? aispaceColor : "#5F6368" }}>
          <HilfeIcon height={20} width={20}/>
        </div>
      )
    },
    ...(isSuperAdmin || data?.user_role === "ADMIN" ? [{
      path: "/settings", 
      text: "Einstellungen", 
      icon: (isActive) => (
        <div style={{ color: isActive ? aispaceColor : "#5F6368" }}>
          <Settings height={20} width={20}/>
        </div>
      )
    }] : []),
    // ...(isSuperAdmin ? [{
    //   path: "/admin",
    //   text: "Administrator",
    //   icon: (isActive) => (
    //     <div className={isActive ? "text-[#ef8000]" : "text-[#5F6368]"}>
    //       <Settings />
    //     </div>
    //   )
    // }] : []),
  ];

  const navigateToRoute = (route) => {
    // Prevent navigation for disabled routes
    if (route.disabled) {
      return;
    }
    
    // Force No License users to stay on hilfe page
    if (data?.user_role === 'No License' && route.path !== '/hilfe') {
      navigate('/hilfe');
      return;
    }
    
    if (window.location.pathname === route.path) {
      window.location.reload();
    } else {
      if (window.location.pathname.includes("chat/")) {
        navigate(route.path);
        window.location.reload();
      }
      else {
        navigate(route.path);
      }
    }
  };  

  return (
    <div className=''>
      <nav className='fixed top-0 left-0 right-0 pb-2 pt-2 pl-5 flex items-center justify-between bg-custom-white_light border-b z-[110]'>
        <div className='flex items-center gap-5'>
          {loading ? (
            <div className='cursor-pointer h-12 w-12 flex items-center justify-center' onClick={() => {
              if (data?.user_role === 'No License') {
                navigate('/hilfe');
              } else {
                navigate('/');
              }
            }}>
              <div className="relative w-6 h-6">
                <div className="absolute inset-0 border-2 border-custom-yellow rounded-full animate-ping opacity-75"></div>
                <div className="absolute inset-0 border-2 border-custom-yellow rounded-full animate-pulse"></div>
              </div>
            </div>
          ) : (
            <img className='cursor-pointer h-12 w-auto' onClick={() => {
              if (data?.user_role === 'No License') {
                navigate('/hilfe');
              } else {
                navigate('/');
              }
            }} src={logoUrl} alt="logo" />
          )}
          <div className='flex gap-2'>
            {routes.map((route, index) => {
              const isActive = location.pathname === route.path;
              const isDisabled = route.disabled;
              return (
                <Button 
                  onClick={() => navigateToRoute(route)} 
                  key={index} 
                  icon={route.icon(isActive)}
                  text={route.text}
                  rounded={true}
                  disabled={isDisabled}
                  className={`${isActive ? 'nav-btn-selected' : 'nav-btn-unselected'} ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                  iconClassName={isActive ? 'navbar-icon-selected' : 'navbar-icon'}
                  textClassName={'navbar-text'}
                  style={{marginRight: '6px'}}
                />
              );
            })}
          </div>
        </div>
        <div className='flex items-center gap-3 pr-5'>
          <p className='text-custom-gray'>{name}</p>
          <div className="relative group" id="profile-dropdown">
            <div 
              className={`bg-custom-yellow w-10 h-10 flex items-center justify-center rounded-full cursor-pointer`}
              onClick={() => setShowLogout(!showLogout)}
              // onMouseEnter={handleMouseEnter}
              // onMouseLeave={handleMouseLeave}
            >
              <p className='text-white font-bold'>{initials}</p>
            </div>
            <div 
              className={`absolute z-[110] top-[calc(100%+2px)] right-0 transition-opacity duration-300 ${showLogout ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
            >
              <div className="w-full h-2 absolute -top-2"></div>
              <button 
                onClick={(e) => {
                  e.stopPropagation(); // Prevent event from bubbling up to document
                  logout();
                }} 
                // onMouseEnter={handleMouseEnter}
                // onMouseLeave={handleMouseLeave}
                className="z-[9999] bg-white border border-gray-300 rounded-md shadow-md pr-20 pl-3 pt-5 pb-5 flex items-center gap-3 hover:bg-gray-50 whitespace-nowrap min-w-[150px]"
              >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39687 15.0156 2.25 14.6625 2.25 14.25V3.75C2.25 3.3375 2.39687 2.98438 2.69063 2.69063C2.98438 2.39687 3.3375 2.25 3.75 2.25H9V3.75H3.75V14.25H9V15.75H3.75ZM12 12.75L10.9688 11.6625L12.8813 9.75H6.75V8.25H12.8813L10.9688 6.3375L12 5.25L15.75 9L12 12.75Z" fill="#5F6368"/>
                </svg>
                <h1>Logout</h1>
              </button>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Nav